import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";

/**
 * Tunn förloppslinje högst upp så att ett klick alltid ger direkt respons,
 * även när nästa sida behöver hämta data först.
 */
export function RouteProgress() {
  const isPending = useRouterState({
    select: (s) => s.status === "pending" || s.isLoading || s.isTransitioning,
  });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isPending) {
      setVisible(true);
      return;
    }
    // Låt linjen köra klart en kort stund så den inte blinkar bort.
    const timer = window.setTimeout(() => setVisible(false), 220);
    return () => window.clearTimeout(timer);
  }, [isPending]);

  if (!visible) return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-x-0 top-0 z-[100] h-0.5 overflow-hidden bg-primary/15"
    >
      <div
        className={`h-full bg-primary transition-[width] ease-out ${
          isPending ? "w-4/5 duration-[1200ms]" : "w-full duration-200"
        }`}
      />
    </div>
  );
}
